import { useMutation } from 'react-query';
import createRoom from '../requests/createRoom';

const useCreateRoomMutation = (options) =>
  useMutation(
    ({ facilityId, formValues }) => createRoom(facilityId, formValues),
    options
  );

export default useCreateRoomMutation;
